import { createSelector, createFeatureSelector } from '@ngrx/store';
import { ActivityState } from '../reducers/activity.reducer';

export const selectActivityState = createFeatureSelector<ActivityState>('postActivity');

export const selectAllActivities = createSelector(
  selectActivityState,
  (state: ActivityState) => state.activities
);

// export const selectActivitiesByPartner = (partnerId: number) =>
//   createSelector(selectAllActivities, (activities) => activities
//   );